/* src/components/project-mandating/project-mandating.component.scss */
:host {
  display: block;
}
.main-wrapper {
  padding-top: 2rem;
}
.start-mandating,
.mandate-status {
  text-align: center;
  margin: 2rem 0;
}
.mandate-info {
  color: var(--vwui-color-light);
}
.mandating-info-icon {
  position: absolute;
  margin-top: 8px;
}
.mandating-info-icon--list-padding {
  padding-left: 12px;
}
.to-execution {
  text-align: center;
  margin: 2rem auto;
}
.mandate-steps {
  position: relative;
  z-index: 1;
  padding: 2rem 0;
}
.mandate-steps::before {
  content: "";
  display: block;
  width: 1px;
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 50%;
  background: var(--vwui-color-neutral-3);
}
.mandate-step {
  position: relative;
  z-index: 1;
  text-align: left;
}
.mandate-step__content {
  position: relative;
  z-index: 2;
  background: #fff;
}
.mandate-step::after {
  content: "";
  display: block;
  height: 1px;
  position: absolute;
  z-index: 1;
  top: 2rem;
  width: calc(5% - 1.5rem);
  background: var(--vwui-color-neutral-3);
}
.mandate-step:nth-child(odd) {
  padding-right: 55%;
}
.mandate-step:nth-child(odd)::after {
  right: 50%;
}
.mandate-step:nth-child(even) {
  padding-left: 55%;
}
.mandate-step:nth-child(even)::after {
  left: 50%;
}
.item-user {
  float: right;
  width: 1.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
  border-radius: 50%;
  color: #fff;
  background: var(--vwui-color-dark);
  text-align: center;
}
.item-user vwui-icon {
  --vwui-icon--size: 0.75rem;
  display: block;
  line-height: 1;
  margin: 0.3rem auto 0 auto;
  color: inherit;
}
.item-title {
  font-weight: 500;
}
.item-date {
  font-weight: 500;
  opacity: 0.3;
}
.item-remark {
  position: relative;
  background: var(--vwui-color-neutral-4);
  padding: 0.6rem 0.8rem;
  margin: 0.6rem 0 0 0;
  border-radius: 5px;
}
.item-remark::after {
  content: "";
  display: block;
  position: absolute;
  border: 10px solid transparent;
  border-left-color: var(--vwui-color-neutral-4);
}
/*# sourceMappingURL=project-mandating.component-ZB7NQBHR.css.map */
